// AS: this is a singleton containing all data for vehicles, monitoring objects and groups of them
import {MonitoringObjectService} from "../providers/monitoring-object-service";
import {Events} from "ionic-angular";
import {UserInfoSingleton} from "./UserInfoSingleton";
import {UserInfo} from "./UserInfo";

export class MonitoringObjectContainer{
  private static _instance: MonitoringObjectContainer;

  // AS: properties
  private _objectGroups: any[]; // groups of objects

  // AS: handle long-pulls to server
  private monitoringObjectsUpdateTimeoutHandler: any;
  private  updateInterval: number = 10000; // AS: in millisecs

  public constructor(
    private moobjService: MonitoringObjectService,
    private events: Events,
  ){
     if(MonitoringObjectContainer._instance){
      //throw new Error("Instance already instantiated. User MonitoringObjectContainer.instance instead.");
      MonitoringObjectContainer._instance.refresh().catch((e) => {console.log(e);});
      return MonitoringObjectContainer._instance;
    }

    this.refresh().catch((e) => {console.log(e);});

    MonitoringObjectContainer._instance = this;

    // AS: let's start updating
    //this.updatePositions(true);
  }

  public static get Instance(){
    // if(!MonitoringObjectContainer._instance._objectGroups){
    //   MonitoringObjectContainer._instance.refresh().catch((e) => { console.log(e); });
    // }
    return MonitoringObjectContainer._instance;
  }

  public get objectGroups(): any[]{
    return this._objectGroups;
  }

  // AS: возвращает все объекты, независимо от групп. Все в кучу
  public get objects(): any[]{
    if(!this._objectGroups){
      return null;
    }

    let o = [];

    this._objectGroups;
    for(let g of this._objectGroups){
      if(g.Vehicles === undefined || g.Vehicles == null){
        continue;
      }
      for(let v of g.Vehicles){
          o.push(v);
      }
    }

    return o;
  }

  public async refresh(){
    return await this.getObjectGroups();
  }

  // AS: methods

  // AS: get monitoring object by id
  public getMonitoringObject(id: number): any{
    if(!this._objectGroups){
      return null;
    }
    for(let g of this._objectGroups){
      if(g.Vehicles === undefined || g.Vehicles == null){
        continue;
      }
      for(let v of g.Vehicles){
        if(v.VehicleId == id){
          return v;
        }
      }
    }

    return null;
  }

  public setMonitoringObject(id: number, pos: any){
    if(!pos)
      return null;

    let v = this.getMonitoringObject(id);
    if(v)
      v.Position = pos.Position;
  }

  public getImage(id: number){
    MonitoringObjectContainer.Instance.moobjService.getImage(id).subscribe(
      img => {
        if(img && img.length > 3){
          let v = this.getMonitoringObject(id);
          if(v)
            v.Img = img;
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  private updatePositions(firstload: boolean = false): Promise<any[]>{
    // if(this.monitoringObjectsUpdateTimeoutHandler){
    //   return;
    // }

    return new Promise<any[]>((resolve, reject) => {
      if(this.monitoringObjectsUpdateTimeoutHandler){
        clearTimeout(this.monitoringObjectsUpdateTimeoutHandler);
        this.monitoringObjectsUpdateTimeoutHandler = null;
      }

      let time = firstload ? new Date() : new Date();
      this.moobjService.getPositions(time.valueOf()).subscribe(
        (positions) => {

          // AS: обновим позиции в списке
          for(let pos of positions){
            this.setMonitoringObject(pos.VehicleId, pos);

            if(firstload){
              // AS: при первой загрузке загрузим также изображения машин
              this.getImage(pos.VehicleId);
            }
          }
          // AS: запустим событие об обновлении позиций
          this.events.publish('positions:updated', positions);

          let userInfo = UserInfoSingleton.instance.info;
          this.updateInterval = userInfo.UserSettings["UpdateInterval"] * 1000;

          this.monitoringObjectsUpdateTimeoutHandler = setTimeout(() => {
            this.updatePositions().catch((e) => {console.log(e);});
          }, this.updateInterval);

          return resolve(positions);
        },
        (err) => {
          console.log(err);
          this.monitoringObjectsUpdateTimeoutHandler = setTimeout(() => {
            this.updatePositions().catch((e) => {console.log(e);});
          }, this.updateInterval * 2);
        }
      );
    });
  }

  public getObjectGroups(filter: string = null): Promise<any>{
    return new Promise((resolve, reject) => {
      this.moobjService.getGroups(filter)
        .subscribe(
          (data) => {
            this._objectGroups = data;

            // AS: let's start updates for our vehicles
            this.updatePositions(true)
              .then((positions) => {
              return resolve();
            })
              .catch((e) => {
                console.log(e);
                return reject(e);
              });
          },
          (err) => {
            console.log(err);
            return reject(err);
          }
        );
    });
  }

  public updateObjectsOfGroup(group: any, obj: any, isnew: boolean) {
    if (!group) {
      return;
    }

    if(isnew == true){
      group.Vehicles.push(obj);
      // group.Vehicles.push({
      //   GarageNumber: obj.GarageNumber,
      //   Name: obj.Name,
      //   StateNumber: obj.StateNumber
      // });
    }else{
      for(let v of group.Vehicles){
        if(v.VehicleId === obj.VehicleId){
          //v = obj;
          v.GarageNumber = obj.GarageNumber;
          v.Name = obj.Name;
          v.StateNumber = obj.StateNumber;
          v.Vin = obj.Vin;
          v.Controller = obj.Controller;
        }
      }
    }
  }

  // AS: обновить список групп
  public updateGroupList(group: any, isnew: boolean) {
    if (!this._objectGroups) {
      this._objectGroups = [];
    }

    if(isnew == true){
      this._objectGroups.push({
        VehiclegroupId: group.id,
        Name: group.name,
        Description: group.description
      });
    }else{
      for(let g of this._objectGroups){
        if(g.VehiclegroupId == group.id){
          //g = group;
          g.Name = group.name;
          g.Description = group.description;
        }
      }
    }
  }

  public clear(){
    if(this.monitoringObjectsUpdateTimeoutHandler){
      clearTimeout(this.monitoringObjectsUpdateTimeoutHandler);
      this.monitoringObjectsUpdateTimeoutHandler = null;
    }
    this._objectGroups = [];
  }

}



// WEBPACK FOOTER //
// ./src/infrastructure/MonitoringObjectContainer.ts